export const EMPTY_DATASET_NAME_WARN = 'Were not provided dataset name';
export const UNKNOWN_DATASET_NAME_WARN = 'An unknown dataset name was provided';
